import { AdtHolidaysActions, AdtHolidaysActionTypes } from '../../actions/holidays.actions';

/**
 * Holidays state
 */
export interface HolidaysState {
    loading: boolean;
    holidays: Date[];
}

/**
 * Initial state of holidays
 */
export const initialState: HolidaysState = {
    loading: false,
    holidays: undefined,
};

/**
 * Holidays reducer
 * @param {HolidaysState} state Holidays state
 * @param {AdtHolidaysActions} action holidays actions
 * @returns {HolidaysState}
 */
export function adtHolidaysReducer(state = initialState, action: AdtHolidaysActions): HolidaysState {
    switch (action.type) {
        case AdtHolidaysActionTypes.FETCH_HOLIDAYS:
            return {
                ...state,
                loading: true,
            } as HolidaysState;
        case AdtHolidaysActionTypes.LOAD_HOLIDAYS:
            return {
                ...state,
                holidays: [...action.payload],
                loading: false,
            } as HolidaysState;
        case AdtHolidaysActionTypes.RESET:
            return {
                ...initialState,
            };
        default:
            return state;
    }
}
